import * as React from "react"

import { cn } from "@src/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "sl-flex sl-h-9 sl-w-full sl-rounded-md sl-border sl-border-input sl-bg-transparent sl-px-3 sl-py-1 sl-text-sm sl-shadow-sm sl-transition-colors file:sl-border-0 file:sl-bg-transparent file:sl-text-sm file:sl-font-medium placeholder:sl-text-muted-foreground focus-visible:sl-outline-none focus-visible:sl-ring-1 focus-visible:sl-ring-ring disabled:sl-cursor-not-allowed disabled:sl-opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
